'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceName = exports.deleteServiceName = exports.setServiceName = undefined;

var _clientUtils = require('./clientUtils');

var loginCookieName = 'AgamaLogin';

var setServiceName = exports.setServiceName = function setServiceName(serviceName) {
  return (0, _clientUtils.createCookie)(loginCookieName, serviceName, 365);
};
var deleteServiceName = exports.deleteServiceName = function deleteServiceName() {
  return (0, _clientUtils.createCookie)(loginCookieName, '', -1);
};
var getServiceName = exports.getServiceName = function getServiceName() {
  return (0, _clientUtils.getCookie)(loginCookieName);
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/loginCookieUtils.js
// module id = 212
// module chunks = 0